export const HustleUpPatternIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="103" height="105" viewBox="0 0 103 105" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M57.9772 93.0801C54.4121 99.9322 47.3292 104.23 39.6051 104.23H2.59141C0.64957 104.23 -0.600666 102.171 0.29551 100.448L19.6637 63.2217H73.5104L57.9772 93.0801ZM100.004 0C101.947 0 103.198 2.05992 102.301 3.7832L82.9342 41.0088H29.0875L44.6207 11.1514C48.1857 4.2991 55.2686 0 62.9928 0H100.004Z"
      fill="url(#paint0_linear_4898_33119)"
      fillOpacity="0.3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4898_33119"
        x1="-1.52836"
        y1="79.143"
        x2="118.989"
        y2="39.0864"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.3125" stopColor="white" stopOpacity="0.3" />
        <stop offset="0.557192" stopColor="white" stopOpacity="0.6" />
        <stop offset="0.807292" stopColor="white" stopOpacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
)
